import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './DegerlendirmeSureci.css';

function DegerlendirmeSureci() {
  return (
    <div className="degerlendirme-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>BİLDİRİ DEĞERLENDİRME SÜRECİ</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container">
        <article className="main-card">
          <section className="info-block">
            <h3>Değerlendirme Esasları</h3>
            <p>
              Sisteme yüklenen bildirilerin <strong>Genişletilmiş Özet</strong> biçiminde olması ve Yazım Kurallarına uygun olması gerekir. 
              Buna uymayan bildiriler değerlendirilmeye alınmaz.
            </p>
            <p>
              İlgili alan koordinatörleri tarafından gözden geçirilen bildiriler, Kongre Hakem Havuzunda yer alan en az <strong>2 hakeme</strong> gönderilir. 
              Hakemler, yazar ve kurum isimlerini görmeksizin (kör hakemlik), bildirileri değerlendirme ölçütlerine göre puanlandırırlar.
            </p>
            <p>
              Alan koordinatörleri, hakem raporlarını ve puan sıralamasını dikkate alarak her bir bildiri için kabul ya da ret kararı verirler. 
              Bu kararlar Danışma Kurulu’nun onayına sunulur ve nihai karar internet sayfası üzerinden duyurulur.
            </p>
          </section>

          <section className="notice-box">
            <h4>Bildiri Sunum Sınırı</h4>
            <p>
              Bir yazar, birden fazla bildiri başvurusunda bulunabilir; ancak <strong>en fazla iki bildiri</strong> sunabilir. 
              Kabul edilen bildiriler belirlenirken, yazarın hakemlerden en yüksek puanı alan ilk iki bildirisi onaylanacaktır.
            </p>
          </section>

          <section className="info-block" style={{marginTop: '40px'}}>
            <h3>Etik Kurul Onayı Hakkında</h3>
            <p>
              Özgün bildiri araştırmalarında etik kurul onayı alınması gerekmektedir. 
              Ancak, bildiriler kitabının tam metin olarak yayımlanmadığı durumlarda, özet bildiri için etik kurul onayı alınmamış olması etik açıdan sorun olarak değerlendirilmemektedir.
            </p>
            <p>
              Ulusal Yönetim ve Organizasyon Kongremizin bildiriler kitabının <strong>genişletilmiş özet</strong> olarak yayınlanacağı dikkate alındığında, kongrede sunulmak üzere önerilecek bildiriler için <strong>etik kurul onayı istenmemektedir</strong>.
            </p>
            <p className="note-text">
              * İnsan, hayvan veya kişisel verilerin kullanıldığı özgün araştırmalarda etik kurul durumu (alınmıştır, alınmamıştır veya gerekli değildir şeklinde) isteğe bağlı olarak belirtilebilir.
            </p>
          </section>
        </article>
      </main>

      <Footer />
    </div>
  );
}

export default DegerlendirmeSureci;